import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=2e49988a&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=2e49988a&prod&scoped=true&lang=less"
import style1 from "./ChatWindow.vue?vue&type=style&index=1&id=2e49988a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e49988a",
  null
  
)

export default component.exports